import './header-menu-core.js';

/*
 * BGShopping desktop mega-menu hover guard.
 * Keep the native Shopify menu logic, but do not let a desktop submenu
 * disappear while the pointer is travelling from the top-level item into it.
 * Touch/mobile and keyboard focus keep Shopify's native behaviour.
 */
const HeaderMenu = customElements.get('header-menu');

if (HeaderMenu && !HeaderMenu.prototype.__bgshoppingHoverGuard) {
  const nativeDeactivate = HeaderMenu.prototype.deactivate;
  const closeTimers = new WeakMap();
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const clearCloseTimer = (menu) => {
    const timer = closeTimers.get(menu);
    if (timer) clearTimeout(timer);
    closeTimers.delete(menu);
  };

  const pointerStillInsideMenu = (menu) => {
    if (!menu || !menu.isConnected) return false;

    if (menu.matches(':hover')) return true;
    if (menu.querySelector('.menu-list__list-item:hover, .menu-list__submenu:hover')) return true;

    const overflow = menu.refs?.overflowMenu?.shadowRoot?.querySelector('[part="overflow"]');
    if (overflow?.matches(':hover')) return true;

    return false;
  };

  const scheduleClose = (menu, event, firstDelay = 650) => {
    clearCloseTimer(menu);

    const check = () => {
      if (pointerStillInsideMenu(menu)) {
        closeTimers.set(menu, setTimeout(check, 160));
        return;
      }

      closeTimers.delete(menu);
      nativeDeactivate.call(menu, event);
    };

    closeTimers.set(menu, setTimeout(check, firstDelay));
  };

  HeaderMenu.prototype.deactivate = function bgshoppingDeactivate(event) {
    const isDesktopPointerLeave =
      finePointer.matches &&
      event &&
      event.type === 'pointerleave' &&
      event.target instanceof Element;

    if (!isDesktopPointerLeave) {
      clearCloseTimer(this);
      return nativeDeactivate.call(this, event);
    }

    scheduleClose(this, event);
  };

  document.addEventListener(
    'pointerenter',
    (event) => {
      if (!finePointer.matches || !(event.target instanceof Element)) return;
      const menu = event.target.closest('header-menu');
      if (menu) clearCloseTimer(menu);
    },
    true
  );

  HeaderMenu.prototype.__bgshoppingHoverGuard = true;
}

/*
 * BGShopping mega-menu visibility fix.
 * The native Horizon menu uses a dynamic clip/translate calculation that can
 * cut off the first rows when the submenu height changes after hydration.
 * Keep the submenu hit area attached to the header, remove the clipping, and
 * move the visible menu content 72px lower (roughly two menu rows).
 * Desktop only. Mobile drawer remains untouched.
 */
if (!document.getElementById('bgshopping-mega-menu-visibility-fix')) {
  const style = document.createElement('style');
  style.id = 'bgshopping-mega-menu-visibility-fix';
  style.textContent = `
    @media screen and (min-width: 750px) {
      .menu-list__list-item:where(:not([slot='overflow'])) > .menu-list__submenu {
        top: calc(100% - 1px + var(--border-bottom-width)) !important;
        clip-path: none !important;
        padding-top: 72px !important;
      }

      [data-submenu-overlap-bottom-row]
        .menu-list__list-item:where(:not([slot='overflow'])) > .menu-list__submenu {
        clip-path: none !important;
      }

      .menu-list__submenu-inner {
        transform: none !important;
        max-height: calc(80vh - var(--header-height) - 72px) !important;
        overflow-y: auto;
        overflow-x: hidden;
      }

      .overflow-menu::part(overflow) {
        top: calc(100% - 1px + var(--border-bottom-width)) !important;
        clip-path: none !important;
        padding-top: 72px !important;
      }

      .overflow-menu::part(overflow-list) {
        transform: none !important;
        max-height: calc(80vh - var(--header-height) - 72px) !important;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
  `;
  document.head.appendChild(style);
}
